import { render, staticRenderFns } from "./TvaSlider.vue?vue&type=template&id=10e865a7&scoped=true&"
import script from "./TvaSlider.vue?vue&type=script&lang=js&"
export * from "./TvaSlider.vue?vue&type=script&lang=js&"
import style0 from "./TvaSlider.vue?vue&type=style&index=0&id=10e865a7&lang=scss&scoped=true&"
import style1 from "./TvaSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e865a7",
  null
  
)

export default component.exports